
import {isDoctorApp} from '@/utils/utils';

interface Options {
    needLogin?: '0' | '1';
}

export function withDoctorboxWebview(url: string, needLogin: '0' | '1' = '0') {
    return `bddoctorbox://app/web?url=${encodeURIComponent(url)}&needLogin=${needLogin}`;
}

export function navigate(url: string, options?: Options) {
    let nextUrl = url;
    if (isDoctorApp()) {
        nextUrl = withDoctorboxWebview(url, options?.needLogin);
    }

    window.location.href = nextUrl;
}
